export default "/images/seller-bg.png?07295e160023a6eb11284a0abde53c82";